import { inject, Injectable, Injector } from '@angular/core';
import { WiegungService } from './wiegung-service';
import { Material } from '../types/material';
import { SOFTLINE_SERVICE_HTTP, Store } from '@softline/core';

@Injectable()
export class ZwischenwiegungWiegungService extends WiegungService<Material> {

  readonly type = 'ZWISCHENWIEGEN';
  readonly isMaterialRequired = false;
  readonly isOrderRequired = false;

  constructor() {
    super(inject(SOFTLINE_SERVICE_HTTP), inject(Store), inject(Injector));
    console.log('ZwischenwiegungWiegungService');
  }

  weighMaterial(material: Material): Promise<void> {
    return Promise.resolve(undefined);
  }
}